(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("lzblW", function(module, exports) {
const $fb35ac4911525476$var$scrollUpElement = document.getElementById("c-scroll-up");
if ($fb35ac4911525476$var$scrollUpElement !== null) {
    const offsetFromTop = Number($fb35ac4911525476$var$scrollUpElement.getAttribute("data-offset-from-top")) || 100; // if not set default is 100px
    const isInLimit = ()=>document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop;
    const scrollHandle = ()=>{
        $fb35ac4911525476$var$scrollUpElement.classList.toggle("--active", isInLimit());
    };
    const scrollTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    window.onscroll = scrollHandle;
    $fb35ac4911525476$var$scrollUpElement.addEventListener("click", scrollTop);
}

});

})();
//# sourceMappingURL=scroll-up.896004c4.js.map
